// extracted by css-extract-rspack-plugin
export default {"layoutWrapper":"layoutWrapper-iYqK0C","mainContent":"mainContent-_Q3YH7","rightRail":"rightRail-iZO9zF"};